(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/services/swish-socket.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/services/swish-socket.js');

'use strict';

const subscribe = cb => {
  function callbackFunction(data) {
    cb === null || cb === void 0 || cb(data === null || data === void 0 ? void 0 : data.swishStatusReply);
  }
  svs.core.socket.subscribe('/payment/1/swish/status', callbackFunction, window, true, false);
};
const unsubscribe = cb => {
  svs.core.socket.unsubscribe('/payment/1/swish/status', cb);
};
svs.accountservicesReact.deposit.services.swishSocket = {
  subscribe,
  unsubscribe
};

 })(window);